<template>
  <div data-cy="name-new-owner" class="name-owner-link">
    <div v-if="this.mode === 'action-menu'" class="action-link" @click.stop @click="openModal">
      <span>{{ $t('community.communityInfo.nameOwner') }}</span>
    </div>
    <div v-if="this.mode === 'link'" class="link hover-effect" @click="openModal">
      <img src="@/assets/ArrowHLink14.svg" />
      <span>{{ $t('community.communityInfo.nameOwner') }}</span>
    </div>
    <modal @close="closeModal()"
           v-if="showModal"
           height="450px"
           overflow-y="auto"
    >
      <div slot="header">
        {{ $t('community.communityInfo.nameOwner') }}
      </div>
      <div slot="body">
        <div class="content">
          <SearchInput type="user" />
          <div class="result-container">
            <div v-if="hasSearched && (!users || users.length === 0)">
              {{ $t('search.search.noResult') }}
            </div>
            <NameOwnerSearchResult :users="users" :owner-id="ownerId||currentOwnerId" @select="onSelectOwner" />
          </div>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <div class="messg">
          <div class="errorMessage">
            {{ errorMessage }}
          </div>
        </div>
        <v-button :on-click="saveOwner"
                  data-cy="submit-new-owner"
                  :disabled="shouldButtonBeDisabled()"
        >
          {{ $t('post.postForm.save') }}
        </v-button>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/shared/Modal'
import VButton from '@/components/shared/VButton'
import SearchInput from '../search/SearchInput'
import { mapState } from 'vuex'
import NameOwnerSearchResult from './NameOwnerSearchResult'

export default {
  name: 'NameOwnerModal',
  components: { Modal, VButton, SearchInput, NameOwnerSearchResult },
  data() {
    return {
      showModal: false,
      ownerId: undefined,
      errorMessage: undefined
    }
  },
  props: {
    currentOwnerId: {
      type: String,
      default: undefined
    },
    communityId: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'action-menu'
    }
  },
  computed: {
    ...mapState({
      users: state => state.search.searchResult.user,
      hasSearched: state => state.search.hasSearched
    })
  },
  methods: {
    onSelectOwner(userId) {
      this.ownerId = userId
    },
    closeModal() {
      this.showModal = false
      this.$store.dispatch('resetSearch')
    },
    openModal() {
      this.showModal = true
    },
    shouldButtonBeDisabled() {
      return this.ownerId == null || this.ownerId === this.currentOwnerId
    },
    saveOwner() {
      this.errorMessage = undefined
      this.$store
        .dispatch('addOwnerRequest', { communityId: this.communityId, userId: this.ownerId })
        .catch(() => {
          this.errorMessage = this.$t('common.somethingWentWrong')
        })
        .then(() => {
          this.closeModal()
          let message = this.$t('notification.notifOwner.theRequestToTransferOwnership')
          let messageResult = this.$t('notification.notifOwner.hasBeenSent')
          this.$toasted.global.success(message + ' ' + messageResult)
        })
    }
  }
}
</script>

<style scoped lang="scss">

.link {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 1.2rem;

  &:hover {
    text-decoration: underline;
  }
}

.name-owner-link {
  width: 100%;

  .action-link {
    color: $primary-color;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -ms-flex-pack: start;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 12px;

    &:hover {
      cursor: pointer;
      background-color: $primary-color;
      color: white;
    }
  }
}

.content {
  padding: 10px 24px 0 24px;

  .result-container {
    height: 200px;

    @media (max-width: $header-change) {
      height: calc(100vh - 200px);
    }
    overflow-y: auto;
  }
}

.modal-footer {
  box-shadow: inset 0 1px 0 0 #d8d8d8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 10px 24px;

  .messg {
    display: flex;

    .savingMessage {
      margin: 24px 0 24px 24px;
      color: $primary-color;
    }

    .errorMessage {
      margin: 24px 0 24px 0;
      color: $cerise-color;
    }
  }
}

</style>
